import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/bg.jpg'


const _withScopeId = n => (_pushScopeId("data-v-1e87c9b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "page-default page-media" }
const _hoisted_3 = { class: "path-links" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_5 = { class: "header" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "gospel-first-body",
  itemscope: "",
  itemtype: "https://schema.org/Article"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))

import gospel, { State } from '@/store/gospel/home';
import i18, { State as I18State } from '@/store/i18';
import { computed, ref } from "vue";
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const gospelState = computed<State>(() => store.state[gospel.name])
const steps = computed(() => gospelState.value.setps)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].gospel)
const langCommon = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].common)

const onIndex = ref(0)

function onPrev() {
    if (onIndex.value > 0) {
        onIndex.value--
    }
}

function onNext() {
    if (onIndex.value < steps.value.length - 1) {
        onIndex.value++
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "link line",
          to: "/gospel"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(lang).gospel), 1)
          ]),
          _: 1
        }),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_unref(lang).homeTitle), 1)
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(steps), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(onIndex.value === index ? 'active' : null),
              onClick: ($event: any) => (onIndex.value = index)
            }, _toDisplayString(item.title), 11, _hoisted_6))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_unref(steps)[onIndex.value])
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  innerHTML: _unref(steps)[onIndex.value].content
                }, null, 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              (onIndex.value > 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: onPrev,
                    class: "prev"
                  }, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(_unref(langCommon).prev_page), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (onIndex.value < _unref(steps).length - 1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: onNext
                  }, [
                    _createTextVNode(_toDisplayString(_unref(langCommon).next_page) + " ", 1),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})